import useSWR from 'swr'
import { NotificationItem } from './types'
import { apiV2 } from 'lib/api/v2'
import { PageableResponse } from 'lib/api/v2/types'
import dayjs from 'dayjs'

interface Params {
  page?: number
  size?: number
  startDate?: Date
  endDate?: Date
}

type NotificationsResponse = {
  data: PageableResponse<NotificationItem>
}

const formatDate = (date: Date) => dayjs(date).format('YYYY-MM-DD')

async function fetcher([, params]: [string, Params]) {
  const { data } = await apiV2.get<NotificationsResponse>(
    'private/notifications',
    {
      params: {
        page: params.page ?? 0,
        size: params.size ?? 10,
        startDate: params.startDate ? formatDate(params.startDate) : undefined,
        endDate: params.endDate ? formatDate(params.endDate) : undefined
      }
    }
  )

  return data.data
}

export const useNotifications = (params: Params = {}) =>
  useSWR(['notifications', params], fetcher)
